export const FETCH_PATH_SETTINGS_REQUEST =
  'pathSettings/FETCH_PATH_SETTINGS_REQUEST'
export const FETCH_PATH_SETTINGS_SUCCESS =
  'pathSettings/FETCH_PATH_SETTINGS_SUCCESS'
export const FETCH_PATH_SETTINGS_FAILURE =
  'pathSettings/FETCH_PATH_SETTINGS_FAILURE'

export const UPDATE_PATH_SETTINGS_REQUEST =
  'pathSettings/UPDATE_PATH_SETTINGS_REQUEST'
export const UPDATE_PATH_SETTINGS_SUCCESS =
  'pathSettings/UPDATE_PATH_SETTINGS_SUCCESS'
export const UPDATE_PATH_SETTINGS_FAILURE =
  'pathSettings/UPDATE_PATH_SETTINGS_FAILURE'

export const UPDATE_FIELD = 'pathSettings/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'pathSettings/SET_DEFAULT_DATA'
